<!-- eslint-disable vue/no-parsing-error -->
<template>
	<div class="general-container">
		<router-link :to="{ name: 'home' }">
			<span class="back-to-event"> 
				<img
					:src="require('@/assets/images/ic-back.svg')"
					:alt="$t('wegow.altIcon')"
					class="close-icon mr-2"
				/>				
				Volver a todos los eventos
			</span>
		</router-link>
		<div class="list-container">
			<div v-if="event.id" class="card-large">
					<div class="flex event-header">
						<img :src="getEventImage(event)" :alt="'imagen del evento' + event.title " class="w-1/3 pr-1">
						<div class="flex flex-col justify-center space-y-2 md:space-y-4 pl-1 md:pl-10 w-full event-info">
							<h3 class="mb-4 md:mb-0">{{ capitalizeFirstLetter(event.title) }}</h3>
							<div class="flex justify-start flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-8">
								<span class="flex items-center space-x-2">
									<img
										:src="require('@/assets/images/ic-calendar.svg')"
										:alt="$t('wegow.altIcon')"
										class="close-icon cursor-pointer"
									/>
									<span>
										{{eventDate(event)}}
									</span>
								</span>
								<span class="flex items-center space-x-2">
									<img
										:src="require('@/assets/images/ic-clock.svg')"
										:alt="$t('wegow.altIcon')"
										class="close-icon cursor-pointer"
									/>
									<span>
										{{eventHour(event)}}
									</span>
								</span>
								<span class="flex items-center space-x-2">
									<img
										:src="require('@/assets/images/ic-location.svg')"
										:alt="$t('wegow.altIcon')"
										class="close-icon cursor-pointer"
									/>
									<span>
										{{event.venue?.name}}
									</span>
								</span>
							</div>
							<!-- <span class="md:hidden flex items-center space-x-2">
								<img
									:src="require('@/assets/images/ic-location.svg')"
									:alt="$t('wegow.altIcon')"
									class="close-icon cursor-pointer"
								/>
								<span>
									{{event.venue?.name}}
								</span>
							</span> -->
						</div>
					</div>
                <div class="md:px-8" :class="vaildMedias.length > 0 ? 'section' : '' ">
                    <event-info />

                </div>
                <div v-if="vaildMedias.length > 0" class="md:px-8">
                    <event-gallery />

                </div>
                <!-- <div class="section md:px-8">
                    <event-location />

                </div>
                <div class="md:px-8">
                    <event-accommodation />

                </div> -->
                <!-- <div>
                    <event-transport />
                </div> -->

				
				<div class="purchase-container flex justify-center mt-12">
					<router-link 
						:to="{
							name: 'EventPurchase',
							params: {
								slug: event.slug,
							}
						}"
					>
						<wegow-button
							id="square-banner"
							color="grey"
							size="xxl"
							type="button"
							:text="$t('wegow.purchase.buy')"
							@click="navigateToPurchase(event)"
						/>
					</router-link>
				</div>
			</div>
		</div>
	</div>

</template>

<script setup>
import { useEvent } from "@/composables/useEvent";

import WegowButton from "@/components/forms/WegowButton";
// import EventHeader from "@/components/events/EventHeader";
import EventInfo from "@/components/events/EventInfo";
import EventGallery from "@/components/events/EventGallery";
// import EventLocation from "@/components/events/EventLocation";
// import EventAccommodation from "@/components/events/EventAccommodation";
// import EventTransport from "@/components/events/EventTransport";


import { useI18n } from "vue-i18n";
import { onBeforeMount, ref } from "vue";
import { metas } from "@/plugins/metas";
import { formatLongDate, formatHour } from "@/plugins/date-formater";
import { onBeforeRouteUpdate, useRouter, useRoute } from "vue-router";
import { ROUTE_VALUES } from "@/constants.js";
import { useModalHandler } from "@/plugins/useModalHandler";

const {
  openErrorModal
} = useModalHandler();

const { details:event, vaildMedias, getDetails, getEventMedia } = useEvent();
const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const loaded = ref(false);
const timezone = ref("Europe/Madrid");
const windowWidth = ref(0);

const init = route =>
  (async route => {
    loaded.value = false;
    metas.methods.setCanonical(route);
    await getDetails(route.params.slug);
    if (event.value && event.value.id) {
      loaded.value = true;
      changeUrlToEventType(route);
      setMetasConfig();
      windowWidth.value = window.innerWidth;

      await getEventMedia(event.value);

    //   TODO: Revisar estos parametros para añadir en el widget
    //   if (route.query.r) {
    //     referenceQuery.value.query = { r: route.query.r };
    //     setReference(route.query.r);
    //   }
    //   if (route.hash) {
    //     referenceQuery.value.hash = route.hash;
    //   }

      timezone.value = (await Intl.DateTimeFormat())
        .resolvedOptions()
        .timeZone.trim();
    } else {
      openErrorModal({
        modal: {
          title: "wegow.error.chargeError",
          btn_message: "wegow.headers.goToWegow",
          button_method: () => {
            router.push({
              name: "MainPage"
            });
          }
        }
      });
    }
  })(route).catch(() => router.push({ name: "NotFound" }));

onBeforeMount(() => init(route));
onBeforeRouteUpdate(to => init(to));

const eventDate = (event) =>{
  // formatDate(event.value.start_date, selectedRegion())
  return formatDate(event.start_date, 'es', event)
};
const formatDate = (date, region, event) => {
  let infoDate = formatLongDate(date, region, event.attendance === 2);
  return t("wegow.date.dateFormat", infoDate);
};
const eventHour = (event) =>{
  // formatHour(event.value.start_date, route.params.region)
  return formatHour(event.start_date, 'es')
};

const getEventImage = (event) => {
	if (event.thumbnails?.m_cd) {
		return event.thumbnails?.m_cd;
	} else if (event.image_url) {
		return event.image_url
	} else {
		return require('@/assets/images/placeholder-event.svg')
	}
}

const navigateToPurchase = (event) => {

	router.push({
    name: "EventPurchase",
    params: {
      slug: event.slug,
    }
  });

}

const changeUrlToEventType = route => {
  let newUrl = route.path;
  if (
    event.value.type === 0 &&
    ROUTE_VALUES.festivalStrinigs.some(elemento => {
      return route.path.includes(elemento);
    })
  ) {
    for (let i = 0; i < ROUTE_VALUES.festivalStrinigs.length; i++) {
      let regex = new RegExp(
        "\\b" + ROUTE_VALUES.festivalStrinigs[i] + "\\b",
        "g"
      );
      newUrl = newUrl.replace(regex, ROUTE_VALUES.concertStrinigs[i]);
    }
    history.pushState(null, null, newUrl);
  } else if (
    event.value.type === 1 &&
    ROUTE_VALUES.concertStrinigs.some(elemento => {
      return route.path.includes(elemento);
    })
  ) {
    for (let i = 0; i < ROUTE_VALUES.concertStrinigs.length; i++) {
      let regex = new RegExp(
        "\\b" + ROUTE_VALUES.concertStrinigs[i] + "\\b",
        "g"
      );
      newUrl = newUrl.replace(regex, ROUTE_VALUES.festivalStrinigs[i]);
    }
    history.pushState(null, null, newUrl);
  }
};
const setMetasConfig = () => {
	let artists = event.value.artists
      .map(artist => artist?.name)
      .join(", ")
      .toString();

    // Metas
    let title = "",
      description = "";
    if (event.value.html_personalization) {
      title = event.value.html_personalization.head_title;
      description = event.value.html_personalization.head_meta_description;
    } else if (!event.value.head_meta_description && event.value.type === 0) {
      title = t("general.metas.concertTitle", {
        artists: artists,
        venue: event.value.venue.name,
        city: event.value.city.name,
        start_date: event.value.longDateFormated
      });

      description = t("general.metas.concertDescription", {
        artist: artists,
        event: event.value.title,
        city: event.value.city.name,
        venue: event.value.venue.name
      });
    } else if (!event.value.head_meta_description && event.value.type === 1) {
      title = t("general.metas.festivalTitle", {
        event_title: event.value.title
      });

      description = t("general.metas.festivalDescription", {
        festival: event.value.title
      });
    }

    metas.methods.setMetasHtml(
      {
        title: title,
        description: description,
        noIndex: !event.value.index
      }
    );

    metas.methods.setOpenGraph({
      content: title,
      property: "og:title"
    });
    metas.methods.setOpenGraph({
      content: description,
      property: "og:description"
    });
    metas.methods.setOpenGraph({
      content: event?.value.thumbnails?.m_hor_dt
        ? event.value.thumbnails.m_hor_dt
        : event?.value.image_url,
      property: "og:image"
    });
}

const capitalizeFirstLetter = (text) => {
	return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
</script>

<style lang="scss" scoped>
.general-container {
	background-image: url('@/assets/images/background-all-events.svg');
	// background-image: url('@/assets/images/background-top-navbar.svg');
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	padding-bottom: 100px;
	.back-to-event{
		display: flex;
		padding-top: 30px;
		padding-bottom: 30px;
		color: black;
		max-width: 90vw;
		width: 1000px;
		margin-left: auto;
		margin-right: auto;
		color: white;
		font-weight: 400;
		font-size: 20px;
		
	}
	.list-container {
		// max-height: 200vh;
		// overflow-y: auto;
		background-color: white;
		color: black;
		max-width: 90vw;
		width: 1000px;
		padding: 50px;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 100px;

		&::-webkit-scrollbar-track {
			box-shadow: inset 0 0 6px transparent;
			background-color: transparent;
		}
		&::-webkit-scrollbar {
			width: 8px;
			height: 6px;
			background-color: transparent;
		}
		&::-webkit-scrollbar-thumb {
			background-color: transparent;
			border-radius: 60px;
			width: 13px;
		}


		div.section {
			border-bottom: 1px solid #7f8295;
			// margin-bottom: 12px;
			// margin-top: 12px;
		}
		.event-header {
			height: 160px;
			img {
				object-fit: cover;
			}
			& > div {
				background-color: $backgroundCard;
				color: white;
				h3 {
					font-weight: 700;
					font-size: 20px;
				}
				img {
					height: 22px;
					width: auto;
				}
			}
		}
		.event-description{
			padding: 30px 50px;
			color: #000214;
			h5 {
				font-weight: 700;
				font-size: 20px;
			}

		}
		.purchase-container {
			margin-bottom: 30px;
		}
	}
	@media screen and (max-width: 768px) {
		padding-bottom: 10px;
		.list-container {
			padding: 4px;
			margin-bottom: 10px;
			.event-header {
				height: 200px !important;
			}
		}
	}
}

</style>
